import React from "react";
import './loadGears.scss'

const LoaderGears = () => {
    return(
        <>
            <div id="wrapper">
                <div class="gears" id="two-gears">
                    
                    <div class="gears-container">
                    <div class="gear-rotate"></div>
                    <div class="gear-rotate-left"></div>
                    </div>   
                </div>
            </div>
        </>
    )
}

export default LoaderGears;